import { useEffect, useRef } from 'react';
import { usePushNotifications } from '@/hooks/usePushNotifications';
import { useAuth } from '@/hooks/useAuth';

/**
 * Background component that manages push notification subscription.
 * Auto-subscribes when user is logged in and permissions are granted.
 */
export function PushNotificationManager() {
  const { user } = useAuth();
  const { isSupported, permission, isSubscribed, subscribe } = usePushNotifications();
  const hasAttempted = useRef(false);

  useEffect(() => {
    // Only attempt once per session
    if (hasAttempted.current) return;
    
    // Only auto-subscribe if:
    // 1. User is logged in
    // 2. Push is supported
    // 3. Permission is already granted (don't prompt automatically)
    // 4. Not already subscribed
    if (user && isSupported && permission === 'granted' && !isSubscribed) {
      hasAttempted.current = true;
      
      // Delay subscription to not block initial render
      const timer = setTimeout(() => {
        console.log('[Push] Auto-subscribing user to push notifications');
        subscribe();
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, [user, isSupported, permission, isSubscribed, subscribe]);

  // This component doesn't render anything
  return null;
}
